<template>
  <footer class="site-footer">
    <div class="inner flex content-max-width flex-between">
      <div class="col1">
        <p>Charities Number CC11227 <br>
        Monte Cecilia Housing Trust © 2023 All rights reserved <br>
        <a href="http://www.brownpaperbag.co.nz/" target="_blank" >Web Design by Brownpaperbag</a></p>
      </div>
      <div class="flex col2">
        <ul>
          <li v-for="(social, index) in socialLinks" :key="index">
            <a :href="social.url" target="_blank">
              <img :src="social.src" :alt="social.alt">
            </a>
          </li>
        </ul>
        <a href="/donate" class="donate"> <img src="/images/icons/heart-footer.svg" alt="">Donate</a>
      </div>
    </div>
    <!-- <img src="/images/footer-pattern.svg" class="footer-pattern" alt=""> -->
  </footer>
</template>

<script>
export default {
  props:['socialLinks']
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue